import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import { hasHazardousBusinessPower } from "@/utils/userPermissions";

Vue.use(Router);

// 导入页面组件
const Login = () => import("@/views/login/Login.vue");
const SsoLogin = () => import("@/views/login/SsoLogin.vue");
const Layout = () => import("@/layout/Layout.vue");
const Home = () => import("@/views/home/Home.vue");
const TransportService = () => import("@/views/transportService/TransportService.vue");
const BicyclePlugins = () => import("@/views/bicycle/bicyclePlugins.vue");
const NotFound = () => import("@/views/404/NotFound.vue");
const BicyclePluginsMVGarage = () => import("@/views/bicycle/bicyclePluginsMVGarage.vue");
const aMustPassPlace = () => import("@/views/aMustPassPlace/aMustPassPlace.vue");
const TrackIndex = () => import("@/views/track/index.vue");
const Trajectory = () => import("@/views/track/trajectory.vue");
const TransportServiceIndex = () => import("@/views/transportService/index.vue");
const HistoricalPlugins = () => import("@/views/transportService/historicalPlugIn.vue");
const StandalonePlugin = () => import("@/views/transportService/standalonePlugIn.vue");
const HazardousChemicals = () => import("@/views/hazardousChemicals/index.vue");
const History = () => import("@/views/business/history.vue");
const Plan = () => import("@/views/business/plan.vue");
const Position = () => import("@/views/business/position.vue");
const Fence = () => import("@/views/business/fence.vue");
const BatchTrajectory = () => import("@/views/business/batch.vue");
const ThreeYearTrajectory = () => import("@/views/business/threeYear.vue");
const MultipleTrajectory = () => import("@/views/business/multiple.vue");
const Monitor = () => import("@/views/business/monitor.vue");
const Track = () => import("@/views/business/track.vue");
const FenceManagement = () => import("@/views/electronicFence/fenceManagement.vue");
const FenceVehicle = () => import("@/views/electronicFence/vehicle.vue");
const FenceAlarm = () => import("@/views/electronicFence/fenceAlarm.vue");
const ParkingFence = () => import("@/views/electronicFence/parkingFence.vue");
const ParkingLog = () => import("@/views/electronicFence/parkingLog.vue");
const DetailOpen = () => import("@/views/business/detailOpen.vue");
const ThreeYearDetailOpen = () => import("@/views/business/threeYearDetailOpen.vue");
const ThreeYearStandalonePlugin = () => import("@/views/business/ThreeYearStandalonePlugin.vue");
const UserBalance = () => import("@/views/user/balance.vue");
const UserRecharge = () => import("@/views/user/recharge.vue");
const UserKey = () => import("@/views/user/key.vue");
const UserLog = () => import("@/views/user/log.vue");
const UserManage = () => import("@/views/user/manage.vue");
const UserInterface = () => import("@/views/user/interface.vue");
const UserConsume = () => import("@/views/user/consume.vue");
const UserBill = () => import("@/views/user/bill.vue");
const UserBillDetail = () => import("@/views/user/billDetail.vue");
const BillDownloadCenter = () => import("@/views/user/downloadCenter.vue");
const UserApi = () => import("@/views/user/api.vue");
const PartnerSummary = () => import("@/views/partner/summary.vue");
const PartnerCustomers = () => import("@/views/partner/customers.vue");
const PartnerRechargeLedger = () => import("@/views/partner/rechargeLedger.vue");
const PartnerConsume = () => import("@/views/partner/consume.vue");
const PartnerBalance = () => import("@/views/partner/balance.vue");
const PartnerSettlements = () => import("@/views/partner/settlements.vue");
const PartnerBill = () => import("@/views/partner/bill.vue");
const PartnerBillDetail = () => import("@/views/partner/billDetail.vue");
const InfoManage = () => import("@/views/info/manage.vue");
const DrivingPermit = () => import("@/views/functions/drivingPermit.vue");
const DriversLicense = () => import("@/views/functions/driversLicense.vue");
const BusinessLicense = () => import("@/views/functions/businessLicense.vue");
const Certificate = () => import("@/views/functions/certificate.vue");
const Emission = () => import("@/views/functions/emission.vue");
const NetworkAccess = () => import("@/views/functions/networkAccess.vue");
const ClonePlate = () => import("@/views/functions/clonePlate.vue");
const RoadLicense = () => import("@/views/functions/road.vue");
const Transfer=()=>import("@/views/business/transfer")
// 灵动在途
const InTransit = () => import("@/views/lingdong/InTransit.vue")
const WaybillForm = () => import("@/views/lingdong/WaybillForm.vue")
const WaybillMapPage = () => import("@/views/lingdong/WaybillMapPage.vue")
const FullMap = () => import("@/views/lingdong/FullMap.vue")
const AlarmManage = () => import("@/views/lingdong/AlarmManage.vue")
const FenceManage = () => import("@/views/lingdong/FenceManage.vue")
const DriverManage = () => import("@/views/lingdong/DriverManage.vue")
const AddressBookManage = () => import("@/views/lingdong/AddressBookManage.vue")
const RouteManage = () => import("@/views/lingdong/RouteManage.vue")
const RouteConfigForm = () => import("@/views/lingdong/RouteConfigForm.vue")
const RouteForm = () => import("@/views/lingdong/RouteForm.vue")
// 路由规则
const routes = [
  {
    path: "/",
    redirect: "/home", // 默认跳首页
  },
  {
    path: "/login",
    component: Login,
    hidden: true, // 不在侧边栏显示
  },
  {
    path: "/sso",
    component: SsoLogin,
    hidden: true,
  },
  {
    path: "/lingdong-in-transit/share/:shareId",
    name: "LingDongWaybillShareMapName",
    component: WaybillMapPage,
    hidden: true,
    meta: { title: "运单地图分享" },
  },
  {
    path: "/",
    component: Layout,
    meta: { title: "首页", icon: "el-icon-s-home" },
    children: [
      {
        path: "home",
        name: "HomeName",
        component: Home,
        meta: { title: "首页", icon: "el-icon-s-data" },
      },
    ],
  },
  {
    path: "/index",
    component: Layout,
    redirect: "/index/hazardousChemicals",
    meta: { title: "危化管理", icon: "el-icon-s-home" },
    children: [
      {
        path: "hazardousChemicals",
        name: "HazardousChemicalsName",
        component: HazardousChemicals,
        meta: { title: "危化轨迹", icon: "el-icon-s-data" },
      }
    ],
  }, {
    path: "/",
    component: Layout,
    meta: { title: "货车位置", icon: "el-icon-s-home" },
    children: [
      {
        path: "history",
        name: "HistoryName",
        component: History,
        meta: { title: "货车轨迹", icon: "el-icon-s-data" },
      },
      {
        path: "plan",
        name: "PlanName",
        component: Plan,
        meta: { title: "运输规划", icon: "el-icon-s-data" },
      },
      {
        path: "position",
        name: "PositionName",
        component: Position,
        meta: { title: "货车定位", icon: "el-icon-s-data" },
      },
      {
        path: "fence",
        name: "FenceName",
        component: Fence,
        meta: { title: "必经地/禁行地管理", icon: "el-icon-s-data" },
      },{
        path: "transfer",
        name: "TransferName",
        component: Transfer,
        meta: { title: "运输中转", icon: "el-icon-s-data" },
      },

      {
        path: "batch",
        name: "BatchTrajectoryName",
        component: BatchTrajectory,
        meta: { title: "批量轨迹", icon: "el-icon-s-data" },
      },
      {
        path: "three-year",
        name: "ThreeYearTrajectoryName",
        component: ThreeYearTrajectory,
        meta: { title: "三年轨迹", icon: "el-icon-s-data" },
      },
      {
        path: "multiple",
        name: "MultipleTrajectoryName",
        component: MultipleTrajectory,
        meta: { title: "多车轨迹", icon: "el-icon-s-data" },
      },
      {
        path: "monitor",
        name: "MonitorName",
        component: Monitor,
        meta: { title: "分组监控", icon: "el-icon-s-data" },
      },
      {
        path: "track",
        name: "TrackName",
        component: Track,
        meta: { title: "多车跟踪", icon: "el-icon-s-data" },
      },
      {
        path: "detail-open/:id",
        name: "DetailOpenName",
        component: DetailOpen,
        hidden: true,
        meta: { title: "历史轨迹查询", activeMenu: "/batch" },
      },
      {
        path: "three-year-detail-open/:taskId",
        name: "ThreeYearDetailOpenName",
        component: ThreeYearDetailOpen,
        hidden: true,
        meta: { title: "三年轨迹查询", activeMenu: "/three-year" },
      }
    ],
  },
  {
    path: "/",
    component: Layout,
    meta: { title: "用户中心", icon: "el-icon-user" },
    children: [
      {
        path: "balance",
        name: "UserBalanceName",
        component: UserBalance,
        meta: { title: "用户余额", icon: "el-icon-wallet" },
      },
      {
        path: "recharge",
        name: "UserRechargeName",
        component: UserRecharge,
        meta: { title: "充值记录", icon: "el-icon-wallet" },
      },
      {
        path: "key",
        name: "UserKeyName",
        component: UserKey,
        meta: { title: "密钥信息", icon: "el-icon-key" },
      },
      {
        path: "log",
        name: "UserLogName",
        component: UserLog,
        meta: { title: "请求日志", icon: "el-icon-document" },
      },
      {
        path: "manage",
        name: "UserManageName",
        component: UserManage,
        meta: { title: "管理费", icon: "el-icon-coin" },
      },
      {
        path: "interface",
        name: "UserInterfaceName",
        component: UserInterface,
        meta: { title: "接口调用统计", icon: "el-icon-data-line" },
      },
      {
        path: "consume",
        name: "UserConsumeName",
        component: UserConsume,
        meta: { title: "消费统计", icon: "el-icon-data-line" },
      },
      {
        path: "bill",
        name: "UserBillName",
        component: UserBill,
        meta: { title: "账单查询", icon: "el-icon-tickets" },
      },
      {
        path: "bill-detail",
        name: "UserBillDetailName",
        component: UserBillDetail,
        meta: { title: "账单明细", icon: "el-icon-document" },
      },
      {
        path: "download-center",
        name: "BillDownloadCenterName",
        component: BillDownloadCenter,
        meta: { title: "下载中心", icon: "el-icon-download" },
      },
      {
        path: "api-info",
        name: "UserApiName",
        component: UserApi,
        meta: { title: "API接口信息", icon: "el-icon-connection" },
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    meta: { title: "合伙人中心", icon: "el-icon-s-custom" },
    children: [
      {
        path: "partner-summary",
        name: "PartnerSummaryName",
        component: PartnerSummary,
        meta: { title: "合伙人总览", icon: "el-icon-data-analysis" },
      },
      {
        path: "partner-customers",
        name: "PartnerCustomersName",
        component: PartnerCustomers,
        meta: { title: "名下客户", icon: "el-icon-user" },
      },
      {
        path: "partner-recharge-ledger",
        name: "PartnerRechargeLedgerName",
        component: PartnerRechargeLedger,
        meta: { title: "充值分润", icon: "el-icon-coin" },
      },
      {
        path: "partner-consume",
        name: "PartnerConsumeName",
        component: PartnerConsume,
        meta: { title: "客户消耗", icon: "el-icon-data-line" },
      },
      {
        path: "partner-balance",
        name: "PartnerBalanceName",
        component: PartnerBalance,
        meta: { title: "客户余额", icon: "el-icon-wallet" },
      },
      {
        path: "partner-settlements",
        name: "PartnerSettlementsName",
        component: PartnerSettlements,
        meta: { title: "结算记录", icon: "el-icon-document-checked" },
      },
      {
        path: "partner-bill",
        name: "PartnerBillName",
        component: PartnerBill,
        meta: { title: "账单查询", icon: "el-icon-tickets" },
      },
      {
        path: "partner-bill-detail",
        name: "PartnerBillDetailName",
        component: PartnerBillDetail,
        hidden: true,
        meta: { title: "账单明细", activeMenu: "/partner-bill" },
      },
      {
        path: "partner-download-center",
        name: "PartnerBillDownloadCenterName",
        component: BillDownloadCenter,
        meta: { title: "下载中心", icon: "el-icon-download" },
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    meta: { title: "电子围栏", icon: "el-icon-location-outline" },
    children: [
      {
        path: "fence-management",
        name: "FenceManagementName",
        component: FenceManagement,
        meta: { title: "围栏管理", icon: "el-icon-s-data" },
      },
      {
        path: "fence-vehicle",
        name: "FenceVehicleName",
        component: FenceVehicle,
        meta: { title: "围栏车辆订阅", icon: "el-icon-s-data" },
      },
      {
        path: "fence-alarm",
        name: "FenceAlarmName",
        component: FenceAlarm,
        meta: { title: "围栏告警日志", icon: "el-icon-s-data" },
      },
      {
        path: "parking-fence",
        name: "ParkingFenceName",
        component: ParkingFence,
        meta: { title: "停车围栏", icon: "el-icon-s-data" },
      },
      {
        path: "parking-log",
        name: "ParkingLogName",
        component: ParkingLog,
        meta: { title: "停车日志", icon: "el-icon-s-data" },
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    meta: { title: "信息管理", icon: "el-icon-folder" },
    children: [
      {
        path: "info-manage",
        name: "InfoManageName",
        component: InfoManage,
        meta: { title: "车辆管理", icon: "el-icon-truck" },
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    meta: { title: "信息验证业务", icon: "el-icon-s-operation" },
    children: [
      {
        path: "driving-permit",
        name: "DrivingPermitName",
        component: DrivingPermit,
        meta: { title: "行驶证", icon: "el-icon-document" },
      },
      {
        path: "drivers-license",
        name: "DriversLicenseName",
        component: DriversLicense,
        meta: { title: "驾驶证", icon: "el-icon-document" },
      },
      {
        path: "business-license",
        name: "BusinessLicenseName",
        component: BusinessLicense,
        meta: { title: "营业执照", icon: "el-icon-document" },
      },
      {
        path: "certificate",
        name: "CertificateName",
        component: Certificate,
        meta: { title: "人员从业资格证", icon: "el-icon-document" },
      },
      {
        path: "emission",
        name: "EmissionName",
        component: Emission,
        meta: { title: "排放标准核验", icon: "el-icon-document" },
      },
      {
        path: "network-access",
        name: "NetworkAccessName",
        component: NetworkAccess,
        meta: { title: "入网确认", icon: "el-icon-document" },
      },
      {
        path: "clone-plate",
        name: "ClonePlateName",
        component: ClonePlate,
        meta: { title: "套牌车验证服务", icon: "el-icon-document" },
      },
      {
        path: "road-license",
        name: "RoadLicenseName",
        component: RoadLicense,
        meta: { title: "企业道路运营许可证", icon: "el-icon-document" },
      },
    ],
  },
  // 灵动在途
  {
    path: "/",
    component: Layout,
    meta: { title: "在途智运", icon: "el-icon-s-promotion" },
    children: [
      {
        path: "lingdong-in-transit/create",
        name: "LingDongWaybillCreateName",
        component: WaybillForm,
        hidden: true,
        meta: { title: "新增运单", icon: "el-icon-plus" },
      },
      {
        path: "lingdong-in-transit/edit/:transportNo",
        name: "LingDongWaybillEditName",
        component: WaybillForm,
        hidden: true,
        meta: { title: "编辑运单", icon: "el-icon-edit" },
      },
      {
        path: "lingdong-in-transit/map/:transportNo",
        name: "LingDongWaybillMapName",
        component: WaybillMapPage,
        hidden: true,
        meta: { title: "运单地图", activeMenu: "/lingdong-in-transit" },
      },
      {
        path: "lingdong-in-transit",
        name: "LingDongInTransitName",
        component: InTransit,
        meta: { title: "运单管理", icon: "el-icon-s-order" },
      },
      {
        path: "lingdong-full-map",
        name: "LingDongFullMapName",
        component: FullMap,
        meta: { title: "全图可视", icon: "el-icon-map-location" },
      },
      {
        path: "lingdong-alarm",
        name: "LingDongAlarmName",
        component: AlarmManage,
        meta: { title: "告警管理", icon: "el-icon-bell" },
      },
      {
        path: "lingdong-fence",
        name: "LingDongFenceName",
        component: FenceManage,
        meta: { title: "运单围栏", icon: "el-icon-location-outline" },
      },
      {
        path: "lingdong-driver",
        name: "LingDongDriverName",
        component: DriverManage,
        meta: { title: "司机管理", icon: "el-icon-user" },
      },
      {
        path: "lingdong-address-book",
        name: "LingDongAddressBookName",
        component: AddressBookManage,
        meta: { title: "地址簿", icon: "el-icon-notebook-2" },
      },
      {
        path: "lingdong-route/create",
        name: "LingDongRouteCreateName",
        component: RouteConfigForm,
        hidden: true,
        meta: { title: "新增路线", icon: "el-icon-plus" },
      },
      {
        path: "lingdong-route/edit/:id",
        name: "LingDongRouteEditName",
        component: RouteConfigForm,
        hidden: true,
        meta: { title: "编辑路线", icon: "el-icon-edit" },
      },
      {
        path: "lingdong-route/planner",
        name: "LingDongRoutePlannerName",
        component: RouteForm,
        hidden: true,
        meta: { title: "地图规划", icon: "el-icon-map-location" },
      },
      {
        path: "lingdong-route/view/:id",
        name: "LingDongRouteViewName",
        component: RouteForm,
        hidden: true,
        meta: { title: "查看路线", icon: "el-icon-map-location" },
      },
      {
        path: "lingdong-route",
        name: "LingDongRouteManageName",
        component: RouteManage,
        meta: { title: "路线管理", icon: "el-icon-guide" },
      },
    ],
  },
  // 单独的运输服务页面（无侧边栏）
  {
    path: "/standalone-transport",//轨迹插件
    component: TransportService,
    name: "StandaloneTransportService",
    hidden: true,
  },
  {
    path: "/standalone-bicycle",//运输节点（iframe / web）
    component: BicyclePlugins,
    name: "StandaloneBicycle",
    hidden: true,
  }, {
    path: "/bicycle-plugins-mv-garage",//多车管理后台使用
    component: BicyclePluginsMVGarage,
    name: "StandaBicyclePluginsMVGarage",
    hidden: true,
  }, {
    path: "/standalone-a-must-pass-place",//围栏管理（iframe / web）
    component: aMustPassPlace,
    name: "AMustPassPlaceName",
    hidden: true,
  },
  {
    path: "/standalone-track",//模拟轨迹路线播放
    component: TrackIndex,
    name: "StandaloneTrackIndex",
    hidden: true,
  }, {
    path: "/standalone-trajectory",//模拟轨迹路线播放2
    component: Trajectory,
    name: "StandaloneTrajectory",
    hidden: true,
  }, {
    path: "/standalone-transport-service-index",//轨迹新页面
    component: TransportServiceIndex,
    name: "StandaloneTransportServiceIndex",
    hidden: true,
  }, {
    path: "/standalone-historical-plugins",//历史轨迹插件
    component: HistoricalPlugins,
    name: "StandaloneHistoricalPlugins",
    hidden: true,
  },
  {
    path: "/standalone-standalone-plugin",//运输规划（iframe / web）
    component: StandalonePlugin,
    name: "StandaloneStandalonePlugin",
    hidden: true,
  },
  {
    path: "/standalone-three-year-plugin",//三年轨迹（iframe / web）
    component: ThreeYearStandalonePlugin,
    name: "ThreeYearStandalonePluginName",
    hidden: true,
  },
  {
    path: "/404",
    component: NotFound,
    name: "NotFoundPage",
    hidden: true,
  },
  {
    path: "*",
    component: NotFound,
    hidden: true,
  },
];

const router = new Router({
  mode: "hash",
  scrollBehavior: () => ({ y: 0 }),
  routes,
});
router.beforeEach((to, from, next) => {
  NProgress.start();
  // 检查URL中是否有p和type参数，如果有则跳转到对应页面
  const urlParams = new URLSearchParams(window.location.search);
  const pParam = urlParams.get("p");
  const typeParam = urlParams.get("type");
  if (pParam && typeParam) {
    // 如果有p和type参数，且当前路径是根路径，则跳转到独立的运输服务页面
    if (pParam && (typeParam == 3 || typeParam == 6) && (to.path === "/home" || to.path === "/login" || to.path === "/")) {

      localStorage.setItem("token", pParam);
      next("/standalone-historical-plugins");
      return;
    } else if (
      pParam &&
      (to.path === "/home" || to.path === "/login" || to.path === "/") &&
      !(typeParam == 3 || typeParam == 6)
    ) {
      // 带插件参数 p 但 type 非支持的独立页类型：不走路由首页/登录逻辑，直接 404
      next("/404");
      return;
    }
    next();
  } else {
    if (
      to.path == '/standalone-transport-service-index' ||
      to.path.startsWith('/lingdong-in-transit/share/') ||
      to.path == '/bicycle-plugins-mv-garage' ||
      to.path == '/standalone-standalone-plugin' ||
      to.path == '/standalone-three-year-plugin' ||
      to.path == '/standalone-bicycle' ||
      to.path == '/standalone-a-must-pass-place' ||
      to.path == '/standalone-historical-plugins'
    ) {
      next();
    } else {
      const token = localStorage.getItem("token_bearer");
      // 未登录且访问非登录页，跳转登录（404 可匿名访问，避免插件错误 type 时再被踢回登录）
      if (!token && to.path !== "/login" && to.path !== "/sso" && to.path !== "/404") {
        next("/login");
      } else if (token && to.path === "/login") {
        // 已登录访问登录页，跳首页
        next("/home");
      } else if (
        token &&
        (to.path === "/index/hazardousChemicals" ||
          to.path === "/index" ||
          to.path.startsWith("/index/")) &&
        !hasHazardousBusinessPower()
      ) {
        next("/home");
      } else {
        next();
      }
    }

  }


});

router.afterEach(() => {
  NProgress.done();
});

export default router;
